import { useAuth } from "../utils/useAuth";

const AuthBootstrap = ({ children }) => {
  useAuth(); // ✅ Store is available here
  return children;
};

export default AuthBootstrap;
